module.exports = __webpack_public_path__ + "icon_done-dba357bfbba455428787fefc655ce120.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icon_done.svg
// module id = 260
// module chunks = 88